import { CSSProperties } from 'react'
import styled from 'styled-components'

const ContactItem = styled.a<{underline: boolean}>`
    font-size: 16px;
    display: flex;
    align-items: center;
    font-weight: 100;
    margin: 7px 0;
    color: ${({ theme }) => theme.colour.OFF_WHITE};
    font-family:${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    transition: color 150ms ease;

    ${({underline, theme}) => underline &&
        `&:hover { color: ${theme.colour.COLOUR_LIGHT}; }`
    }
`

const ContactImage = styled.img`
    position: relative;
    margin-right: 10px;
    width: 20px;
    height: 20px;
`

const AddressItem = styled(ContactItem)`
    align-items: flex-start;
    line-height: 1.35;

    ${ContactImage} {
        margin-top: 1px;
    }
`

// newlines in the address string are preserved as address lines
const AddressLines = styled.address`
    font-style: normal;
    white-space: pre-line;
`

type ContactProps = {
    children: string
    to?: string
}

export function PhoneContact({
    children,
    to,
}: ContactProps){
    return (
        <ContactItem href={to} underline={true}>
            <ContactImage 
                src='/assets/img/whatsapp-themed.svg'
                alt='whatsapp icon'
            /> 
            {children}
        </ContactItem>
    )
}

export function EmailContact({
    children,
    to,
}: ContactProps){
    return (
        <ContactItem href={to} underline={true}>
            <ContactImage 
                src='/assets/img/mail-themed.svg'
                alt='mail icon'
            />    
            {children}
        </ContactItem>
    )
}

export function LocationContact({children}: ContactProps){
    return (
        <AddressItem underline={false}>
            <ContactImage 
                        src='/assets/img/location-themed.svg'
                        alt='location icon'
            />
            <AddressLines>{children}</AddressLines>
        </AddressItem>
    )
}